import React, { useState, useEffect } from "react";
import { Modal, Button } from "antd";
import "./KycPopupModal.scss";

const KycPopupModal = ({ visible, onClose, onOkay }) => {
  const [isModalVisible, setIsModalVisible] = useState(visible);

  useEffect(() => {
    setIsModalVisible(visible);
  }, [visible]);

  // Called when "Okay" button is clicked
  const handleOk = () => {
    setIsModalVisible(false);
    onOkay?.();
    onClose?.();
  };

  // Called when modal is closed by user (not "Okay" button)
  const handleCancel = () => {
    setIsModalVisible(false);
    onClose?.();
  };

  return (
    <Modal
      title="KYC Verification Required"
      className="KycPopupModal"
      visible={isModalVisible}
      onCancel={handleCancel}
      centered
      footer={[
        <Button key="submit" type="primary" onClick={handleOk}>
          Okay
        </Button>,
      ]}
    >
      <div className="modal-description">
        <p>Please complete your KYC before signing a contract.</p>
      </div>
    </Modal>
  );
};

export default KycPopupModal;
